import { BehaviorSubject, Observable } from 'rxjs';

class NotificationService {
  private notificationSubject = new BehaviorSubject<string>('');
  public notification$: Observable<string> = this.notificationSubject.asObservable();
  
  private messages: string[] = [
    'Welcome, we are open from 8:00 AM to 5:00 PM, Monday to Friday.Please call us at (850) 765-8120 to make an appointment.',  
  ];
  
  private currentIndex = 0;
  private cycleInterval: ReturnType<typeof setInterval> | null = null;
  private displayDuration = 5000;

  constructor() {
    this.startCycling();
  }

  private startCycling(): void {
    if (this.messages.length === 0) return;
    
    this.notificationSubject.next(this.messages[this.currentIndex]);
    
    this.cycleInterval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.messages.length;
      this.notificationSubject.next(this.messages[this.currentIndex]);
    }, this.displayDuration);
  }

  setNotification(message: string): void {
    if (!this.messages.includes(message)) {
      this.messages.push(message);
    }
    this.notificationSubject.next(message);
  }

  setMessages(messages: string[]): void {
    this.messages = messages;
    this.currentIndex = 0;
    
    if (this.cycleInterval) {
      clearInterval(this.cycleInterval);
    }
    this.startCycling();
  }

  showAppointmentMessage(): void {
    // Implementation if needed
  }
}

export const notificationService = new NotificationService();

